import { __assign, __rest } from "tslib";
import React from 'react';
import { ScreenStatus } from '@marvelapp/core';
import CardCopying from './CardCopying';
import CardDefaultState from './CardDefaultState';
import CardUploadError from './CardUploadError';
import CardUploading from './CardUploading';
function CardHead(_a) {
    var canEditProjects = _a.canEditProjects, renderRetryLink = _a.renderRetryLink, props = __rest(_a, ["canEditProjects", "renderRetryLink"]);
    var borderRadius = props.borderRadius, image = props.image, imagePadding = props.imagePadding, isDragged = props.isDragged, isDraggingMultiple = props.isDraggingMultiple, isSelected = props.isSelected, ratio = props.ratio, status = props.status;
    if (status === ScreenStatus.Uploading) {
        return (React.createElement(CardUploading, { borderRadius: borderRadius, image: image, imagePadding: imagePadding, isDragged: isDragged, isDraggingMultiple: isDraggingMultiple, isSelected: isSelected, ratio: ratio }));
    }
    if (status === ScreenStatus.UploadError) {
        return (React.createElement(CardUploadError, { canEditProjects: canEditProjects, hasImage: !!image, isSelected: isSelected, ratio: ratio, renderRetryLink: renderRetryLink }));
    }
    if (status === ScreenStatus.Copying) {
        return (React.createElement(CardCopying, { borderRadius: borderRadius, image: image, imagePadding: imagePadding, isSelected: isSelected, ratio: ratio }));
    }
    return React.createElement(CardDefaultState, __assign({}, props));
}
export default React.memo(CardHead);
